import { get } from 'lodash'

export const getContractFileName = (refCode, prefix = 'contract-', extension = 'docx', refCodeMaxLength = 199) => {
  refCode = refCode.substr(0, refCodeMaxLength).replace(/\s+/g, '_').replace(/\//g, '_')
  const fileName = `${prefix}${refCode}.${extension}`

  return fileName
}

export const genRefCode = (contractDetail, refCodeFormat, marketList) => {
  const contractStartDate = get(contractDetail, 'startDate', '')
  const contractEndDate = get(contractDetail, 'endDate', '')
  const START_YY = (contractStartDate === '') ? '-' : new Date(contractStartDate).getFullYear().toString().substr(-2)
  const END_YY = (contractEndDate === '') ? '-' : new Date(contractEndDate).getFullYear().toString().substr(-2)

  const rateCodeDataList = get(contractDetail, 'rateCodeList', [])
  let rateCodeList = rateCodeDataList.map((rateCodeItem) => {
    return rateCodeItem.code
  })
  rateCodeList = rateCodeList.sort((a, b) => {
    return (a < b) ? -1 : 1
  })
  const RATECODE = (rateCodeList.length > 0) ? rateCodeList.join('-') : '-'

  const allotmentList = get(contractDetail, 'allotmentList', [])
  const ALLOT_TYPE = (allotmentList.length > 0) ? 'ALT' : 'NOALT'

  const AGENT = get(contractDetail, 'agent.name', '-')
  const HOTEL_CODE = get(contractDetail, 'hotelCode', '-')

  const agentId = get(contractDetail, 'agent.id', '')
  const marketNameList = []
  marketList.forEach((market) => {
    if (market.agentIdList.includes(agentId)) {
      marketNameList.push(market.name)
    }
  })
  const MARKET = (marketNameList.length > 0) ? marketNameList.join('-') : '-'

  let tempRefCode = refCodeFormat.toUpperCase()
  tempRefCode = tempRefCode.replace(/\$\{START_YY\}/g, START_YY)
  tempRefCode = tempRefCode.replace(/\$\{END_YY\}/g, END_YY)
  tempRefCode = tempRefCode.replace(/\$\{RATECODE\}/g, RATECODE)
  tempRefCode = tempRefCode.replace(/\$\{HOTEL_CODE\}/g, HOTEL_CODE)
  tempRefCode = tempRefCode.replace(/\$\{AGENT\}/g, AGENT)
  tempRefCode = tempRefCode.replace(/\$\{MARKET\}/g, MARKET)
  tempRefCode = tempRefCode.replace(/\$\{ALLOT_TYPE\}/g, ALLOT_TYPE)

  return tempRefCode
}

export const applyNewRemark = (contractDetail, remarkData) => {
  const remarkType = get(remarkData, 'remarkType', '')
  const remarkList = get(contractDetail, 'remarkList', [])
  const newRemarkList = remarkList.filter(item => (item.remarkType !== remarkType))

  if (remarkType !== '') {
    newRemarkList.push(remarkData)
  }

  return newRemarkList
}

export const applyRemarkTableStyle = (remarkList, remarkType) => {
  const remarkObj = remarkList.find(remark => remark.remarkType === remarkType)
  const remark = get(remarkObj, 'content', '')
  const appliedRemark = _applyTableStyle(remark)

  return appliedRemark
}

export const applyHotelRemarkTableStyle = (hotelRemark) => {
  const appliedRemark = _applyTableStyle(hotelRemark)

  return appliedRemark
}

const _applyTableStyle = (remark) => {
  let appliedRemark = remark.replace(/<table>/g, '<table style="margin: 0; border-collapse: collapse; border-spacing: 0; border: 1px double #b3b3b3;">')
  appliedRemark = appliedRemark.replace(/<th>/g, '<th style="font-weight: 700; background: #fafafa; min-width: 2em; padding: .4em; border: 1px solid #d9d9d9;">')
  appliedRemark = appliedRemark.replace(/<td>/g, '<td style="min-width: 2em; padding: .4em; border: 1px solid #d9d9d9;">')

  return appliedRemark
}
